import styled from '@emotion/styled';
import { TabletWidth } from '../../../../global.style';

const ContentBoxWidth = 480;

export const ContentBox = styled.div`
  width: 100%;
  max-width: ${ContentBoxWidth}px;
`;

export const MainContentBox = styled(ContentBox)<{ unsetPadding?: boolean }>`
  margin: 0 auto;
  padding-top: ${({ unsetPadding }) => (unsetPadding ? 0 : 50)}px;

  @media (max-width: ${TabletWidth}px) {
    margin-top: 0px;
    padding: ${({ unsetPadding }) => (unsetPadding ? `0` : `40px 16px 24px;`)};
  }
`;

export const ContentBoxWrapper = styled.div<{ offsetVariant?: 80 | 120 }>`
  // a trick to make "responsive" left/right padding - 480px width of a container + {offsetVariant}px padding on each side
  max-width: ${(props) => ContentBoxWidth + (props.offsetVariant ?? 120) * 2}px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-content: center;
  flex-wrap: wrap;
`;
